import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dataset-task",
  "use": "icon-dataset-task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dataset-task\"><path d=\"M226.6 402.8L8.2 280.9 512 0l503.7 280.9-218.3 121.9 217.9 124-185.1 105.3 185.1 105.4L512 1024 8.8 737.5l185.1-105.3L8.8 526.8l217.8-124zM725.2 443L512 561.9 298.8 443l-147.2 83.7L512 731.9l360.4-205.2c0 0.1-147.2-83.7-147.2-83.7zM265.3 672.8l-113.7 64.7L512 942.7l360.4-205.2-113.7-64.7L512 813.3 265.3 672.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol